import { render } from "./ElementsTab.vue?vue&type=template&id=9cd679d2&scoped=true"
import script from "./ElementsTab.vue?vue&type=script&lang=js"
export * from "./ElementsTab.vue?vue&type=script&lang=js"

import "./ElementsTab.vue?vue&type=style&index=0&id=9cd679d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd679d2"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QBadge,QBtn,QTooltip,QIcon,QInput,QSpinner,QList,QItem,QItemSection,QItemLabel,QDialog,QCard,QCardSection,QForm,QCardActions,QLinearProgress});qInstall(script, 'directives', {Ripple,ClosePopup});
